import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { COMPANY } from "@/data/site";

const NAV = [
  { to: "/", label: "Home", id: "home" },
  { to: "/about", label: "About", id: "about" },
  { to: "/services", label: "Services", id: "services" },
  { to: "/products", label: "Products", id: "products" },
  { to: "/projects", label: "Updates", id: "projects" },
  { to: "/csr", label: "CSR", id: "csr" },
  { to: "/contact", label: "Contact", id: "contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40">
      {/* Top utility bar */}
      <div className="bg-black border-b border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-2 flex items-center justify-between text-[11px] font-mono tracking-widest uppercase text-zinc-400">
          <span className="hidden md:inline" data-testid="topbar-gstin">
            GSTIN · {COMPANY.gstin}
          </span>
          <span className="md:hidden" data-testid="topbar-mobile-tag">
            VPS · Hyderabad
          </span>
          <div className="flex items-center gap-4">
            <a
              href={`tel:${COMPANY.phoneSales}`}
              className="flex items-center gap-2 hover:text-[#e63946] transition-colors"
              data-testid="topbar-sales-phone"
            >
              <Phone size={11} /> Sales {COMPANY.phoneSales}
            </a>
            <a
              href={`tel:${COMPANY.phoneService}`}
              className="hidden md:flex items-center gap-2 hover:text-[#e63946] transition-colors"
              data-testid="topbar-service-phone"
            >
              <Phone size={11} /> Service {COMPANY.phoneService}
            </a>
          </div>
        </div>
      </div>

      {/* Main nav */}
      <div className="bg-[#0a0a0c]/85 backdrop-blur-xl border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
          <Link
            to="/"
            className="flex items-center gap-3"
            data-testid="nav-logo"
            onClick={() => setOpen(false)}
          >
            <img
              src={COMPANY.logo}
              alt="VPS"
              className="h-10 w-10 object-contain bg-white p-1"
            />
            <div className="leading-tight">
              <div className="font-display text-base md:text-lg uppercase tracking-tight">
                Voltech <span className="text-[#e63946]">Power</span> Solutions
              </div>
              <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-zinc-500">
                Achieve your Goals
              </div>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {NAV.map((n) => (
              <NavLink
                key={n.id}
                to={n.to}
                end={n.to === "/"}
                data-testid={`nav-${n.id}-link`}
                className={({ isActive }) =>
                  `px-4 py-2 text-[13px] font-display font-bold uppercase tracking-wider transition-colors ${
                    isActive
                      ? "text-[#e63946]"
                      : "text-zinc-300 hover:text-white"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              className="btn-primary ml-3"
              data-testid="nav-quote-cta"
            >
              Get Quote
            </Link>
          </nav>

          <button
            className="lg:hidden p-2 text-white"
            onClick={() => setOpen(!open)}
            data-testid="nav-mobile-toggle"
            aria-label="Open menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>

        {open && (
          <div
            className="lg:hidden border-t border-white/10 bg-[#0a0a0c]"
            data-testid="nav-mobile-menu"
          >
            <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col gap-1">
              {NAV.map((n) => (
                <NavLink
                  key={n.id}
                  to={n.to}
                  end={n.to === "/"}
                  onClick={() => setOpen(false)}
                  data-testid={`nav-mobile-${n.id}-link`}
                  className={({ isActive }) =>
                    `px-3 py-3 font-display font-bold uppercase tracking-wider text-sm border-b border-white/5 ${
                      isActive ? "text-[#e63946]" : "text-zinc-200"
                    }`
                  }
                >
                  {n.label}
                </NavLink>
              ))}
              <Link
                to="/contact"
                onClick={() => setOpen(false)}
                className="btn-primary mt-3 justify-center"
                data-testid="nav-mobile-quote-cta"
              >
                Get Quote
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
